import Table from '../Table/index'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTruck } from '@fortawesome/pro-solid-svg-icons'
import { filter } from 'rxjs/operators'
import loadingSVG from '../../media/loading.svg'
import { Dispatch, SubmitButton } from '../architecture/frontend/index'
import _ from 'lodash'

const columnLayout = [
  {
    field: 'checkbox',
    header: '',
    type: 'checkbox',
    width: '40px',
    fieldStyle: 'justify-center',
  },
  {
    field: 'companyUuid',
    header: 'Id',
    type: 'id',
    style: 'ph2',
    fieldStyle: 'ph2',
    childClass: 'f7',
    sortable: true,
  },
  {
    field: 'status.id',
    header: 'Status',
    type: 'status',
    style: 'ph2',
    fieldStyle: 'ph2',
    sortable: true,
  },
  {
    field: 'ingredient.name',
    header: 'Type',
    type: 'text',
    style: 'ph2',
    fieldStyle: 'ph2',
    childClass: 'f7',
    sortable: true,
  },
  {
    field: 'claimedDate',
    header: 'Claimed',
    type: 'date',
    style: 'tc',
    fieldStyle: 'justify-center',
    childClass: 'f7',
    sortable: true,
  },
  {
    field: 'claimDeniedDate',
    header: 'Denied',
    type: 'deniedDate',
    style: 'tc',
    fieldStyle: 'justify-center',
    childClass: 'f7',
    sortable: true,
    
  },
  {
    field: 'refereeSentDate',
    header: 'Sent Ref',
    type: 'date',
    style: 'tc',
    fieldStyle: 'justify-center',
    childClass: 'f7',
    sortable: true,
  },
  {
    field: 'claimMoisturePercent',
    header: 'M',
    type: 'text',
    groupHeader: 'Claim 12%',
    style: 'bg-light-yellow tc',
    fieldStyle: 'tr ph1',
    sortable: true,
    childClass: 'f7',
  },
  {
    field: 'claimProtein12Percent',
    header: 'P',
    type: 'text',
    groupHeader: 'Claim 12%',
    style: 'bg-light-yellow tc',
    fieldStyle: 'tr ph1',
    sortable: true,
    childClass: 'f7',
  },
  {
    field: 'claimFiber12Percent',
    header: 'F',
    type: 'text',
    groupHeader: 'Claim 12%',
    style: 'bg-light-yellow tc',
    fieldStyle: 'tr ph1',
    sortable: true,
    childClass: 'f7',
  },
  {
    field: 'refereeMoisturePercent',
    header: 'M',
    type: 'text',
    groupHeader: 'Referee 12%',
    style: 'bg-light-green tc',
    fieldStyle: 'tr ph1',
    sortable: true,
    childClass: 'f7',
  },
  {
    field: 'refereeProtein12Percent',
    header: 'P',
    type: 'text',
    groupHeader: 'Referee 12%',
    style: 'bg-light-green tc',
    fieldStyle: 'tr ph1',
    childClass: 'f7',
  },
  {
    field: 'refereeFiber12Percent',
    header: 'F',
    type: 'text',
    groupHeader: 'Referee 12%',
    style: 'bg-light-green tc',
    fieldStyle: 'tr ph1',
    childClass: 'f7',
    sortable: true,
  },
  {
    field: 'refereeFee',
    header: 'Ref Fee',
    type: 'text',
    groupHeader: 'Referee 12%',
    style: 'bg-light-green tc',
    fieldStyle: 'tr ph1',
    childClass: 'f7',
    sortable: true,
  },
  {
    field: 'settlementSentDate',
    header: 'Date Sent',
    type: 'date',
    groupHeader: 'Settlement',
    style: 'bg-light-blue tc',
    fieldStyle: 'justify-center',
    childClass: 'f7',
    sortable: true,
    //preText: '$'
  },
  {
    field: 'settlementMoistureDollars',
    header: 'M',
    type: 'text',
    groupHeader: 'Settlement',
    style: 'bg-light-blue tc',
    fieldStyle: 'tr ph1 fw4 f6',
    sortable: true,
    childClass: 'f7',
    //preText: '$'
  },
  {
    field: 'settlementProteinDollars',
    header: 'P',
    type: 'text',
    groupHeader: 'Settlement',
    style: 'bg-light-blue tc',
    fieldStyle: 'tr ph1  fw4 f6',
    sortable: true,
    childClass: 'f7',
    //preText: '$'
  },
  {
    field: 'settlementFiberDollars',
    header: 'F',
    type: 'text',
    groupHeader: 'Settlement',
    style: 'bg-light-blue tc',
    fieldStyle: 'tr ph1 ',
    sortable: true,
    childClass: 'fw5 f7',
    //preText: '$'
  },
  {
    field: 'settlementTotalDollars',
    header: 'Net',
    type: 'text',
    groupHeader: 'Settlement',
    style: 'bg-light-blue tc',
    fieldStyle: ' tr ph1 f6',
    childClass: 'fw7 f7',
    sortable: true,
    //preText: '$'
  },
  {
    field: 'settlementRemarks',
    header: 'Remarks',
    type: 'text',
    style: '',
    fieldStyle: '',
    sortable: true,
  },
]

const AllSamples = (props) => {
  const data = props.shipments?.rawData
  const loading = props.shipments?.loading ?? true
  const loadMore = !loading && props.shipments?.rawData?.length !== _.find(props.sidebar, sidebar => sidebar.view === 'claimTable')?.count
  const tableName = 'allClaims'
  return (
    <div className='w-100 ph3'>
      <div className='w-100 pa2 ph3 flex items-center justify-between bg-evonik-purple' >
        <div className='flex items-center'>
          <FontAwesomeIcon className='f6 white' icon={faTruck} />
          <div className='pl2 fw7 f6 white'>All Claims </div>
          <div className='h2'></div>
        </div>

        <SubmitButton id={'delete'} className='' 
            defaultChild={ props => (
              <div className='pv2 ph3 br2 bg-evonik-light-purple white pointer f6 fw5'
                onClick={e => Dispatch.nextAction('shipments.delete', { tableName })}>
                  Delete
              </div>
              )}
            loadingChild={ props => (
                <div className='mh3 ' style={{width:40, height: 30}}>
                  <img className='w-100 h-100' src={loadingSVG} alt='loading'/>
                </div>
            )}
            errorChild={ props => (
              <div className='pl3 f7 fw4 red tr pointer'>Error</div>
            )}
            loadingStream={
              Dispatch.getAction('Request.shipments.delete')
                .pipe(
                )
              }
            successStream={
              Dispatch.getAction('Response.shipments.delete')
                .pipe(
                  filter(e => _.isNil(e.errors) && ((!_.isNil(e.data.deleteShipments) ))),
                )
              }
            errorStream={
              Dispatch.getAction('Response.shipments.delete')
                .pipe(
                  filter(e => !_.isNil(e.errors)),
                )}
          />
      </div>
      <div className='w-100 flex ' style={{background: '#f5f3f5'}}>
        <Table _tableName={tableName} _shipments={data} _loading={loading} _columnLayout={columnLayout} _loadMore={loadMore} {...props}/>
        {/* <Table _tableName={'allClaims'} _columnLayout={columnLayout} {...props}/> */}
      </div>
    </div>
  )
}

export default AllSamples